module.exports = __webpack_public_path__ + "img/mecha-mask.3e2ac6dd.svg";